export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4728.726e3e84.jpg";